// extracted by mini-css-extract-plugin
export default {"SkillCategory":"SkillCategory_SkillCategory__oFCpX","Heading":"SkillCategory_Heading__YZGPk","content":"SkillCategory_content__Kge6J","swing-in":"SkillCategory_swing-in__9F7ES"};